<template>
    <div class="mt-[45px] mx-0 mb-[15px]">
        <h2>Scheda tecnica</h2>
        <div class="mb-[15px]">
            <div v-if="mainStore?.perizia?.veicolo?.Motore" class="accordion-cnt" :class="!isMotoreOpen ? 'mb-[30px]' : 'mb-0'"
                @click="openMenu(0)">
                <h3 class="title">Motore</h3>
                <span class="icon-cnt">
                    <span v-if="!isMotoreOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
                </span>
            </div>
            <div v-if="isMotoreOpen" class="cnt-perizie">
                <div v-for="(value, key, idxM) in mainStore?.perizia?.veicolo?.Motore" class="perizia" 
                :class="idxM > 0 ? 'mt-[10px]' : ''" :key="idxM">
                    <div class="left-col">{{ key }}</div>
                    <div class="right-col"><b>{{ value }}</b></div>
                </div>
            </div>

            <div v-if="dimensioniPesiMateriali" class="accordion-cnt" :class="!isMaterialiOpen ? 'mb-[30px]' : 'mb-0'"
                @click="openMenu(4)">
                <h3 class="title">Dimensioni, pesi e materiali</h3>
                <span class="icon-cnt">
                    <span v-if="!isMaterialiOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
                </span>
            </div>
            <div v-if="isMaterialiOpen" class="cnt-perizie">
                <div v-for="(value, key, idxD) in dimensioniPesiMateriali" class="perizia" 
                :class="idxD > 0 ? 'mt-[10px]' : ''" :key="idxD">
                    <div class="left-col">{{ key }}</div>
                    <div class="right-col"><b>{{ value }}</b></div>
                </div>
            </div>

            <div v-if="dimensioniPesi" class="accordion-cnt" :class="!isPesiOpen ? 'mb-[30px]' : 'mb-0'"
                @click="openMenu(1)">
                <h3 class="title">Dimensioni e pesi</h3>
                <span class="icon-cnt">
                    <span v-if="!isPesiOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
                </span>
            </div>
            <div v-if="isPesiOpen" class="cnt-perizie">
                <div v-for="(value, key, idxDP) in dimensioniPesi" class="perizia" 
                :class="idxDP > 0 ? 'mt-[10px]' : ''" :key="idxDP">
                    <div class="left-col">{{ key }}</div>
                    <div class="right-col"><b>{{ value }}</b></div>
                </div>
            </div>

            <div v-if="prestazioniConsumi" class="accordion-cnt" :class="!isConsumiOpen ? 'mb-[30px]' : 'mb-0'"
                @click="openMenu(2)">
                <h3 class="title">Prestazioni e consumi</h3>
                <span class="icon-cnt">
                    <span v-if="!isConsumiOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
                </span>
            </div>
            <div v-if="isConsumiOpen" class="cnt-perizie">
                <div v-for="(value, key, idxP) in prestazioniConsumi" class="perizia" 
                :class="idxP > 0 ? 'mt-[10px]' : ''" :key="idxP">
                    <div class="left-col">{{ key }}</div>
                    <div class="right-col"><b>{{ value }}</b></div>
                </div>
            </div>

            <div v-if="mainStore?.perizia?.veicolo?.Varie" class="accordion-cnt" :class="!isVarieOpen ? 'mb-[30px]' : 'mb-0'"
                @click="openMenu(3)">
                <h3 class="title">Varie</h3>
                <span class="icon-cnt">
                    <span v-if="!isVarieOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
                </span>
            </div>
            <div v-if="isVarieOpen" class="cnt-perizie">
                <div v-for="(value, key, idxV) in mainStore?.perizia?.veicolo?.Varie" class="perizia" 
                :class="idxV > 0 ? 'mt-[10px]' : ''" :key="idxV">
                    <div class="left-col">{{ key }}</div>
                    <div class="right-col"><b>{{ value }}</b></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mainStore } from '../../store/main';

export default {
    data() {
        return {
            mainStore,
            isMotoreOpen: false,
            isMaterialiOpen: false,
            isPesiOpen: false,
            isConsumiOpen: false,
            isVarieOpen: false,
            dimensioniPesiMateriali: null,
            dimensioniPesi: null,
            prestazioniConsumi: null,
        }
    },

    created() {
        if(this.mainStore?.perizia?.veicolo && this.mainStore?.perizia.veicolo['Dimensioni, pesi e materiali']) {
            this.dimensioniPesiMateriali = { ...this.mainStore?.perizia.veicolo['Dimensioni, pesi e materiali'] };
        }
        if(this.mainStore?.perizia?.veicolo && this.mainStore?.perizia.veicolo['Dimensioni e pesi']) {
            this.dimensioniPesi = { ...this.mainStore?.perizia.veicolo['Dimensioni e pesi'] };
        }
        if(this.mainStore?.perizia?.veicolo && this.mainStore?.perizia.veicolo['Prestazioni e consumi']) {
            this.prestazioniConsumi = { ...this.mainStore?.perizia.veicolo['Prestazioni e consumi'] };
        }
    },

    methods: {
        openMenu(menu) {
            switch (menu) {
                case 0:
                    this.isMotoreOpen = !this.isMotoreOpen;
                    this.isMaterialiOpen = false;
                    this.isPesiOpen = false;
                    this.isConsumiOpen = false;
                    this.isVarieOpen = false;
                    break;
                case 1:
                    this.isMotoreOpen = false;
                    this.isMaterialiOpen = false;
                    this.isPesiOpen = !this.isPesiOpen;
                    this.isConsumiOpen = false;
                    this.isVarieOpen = false;
                    break;
                case 2:
                    this.isMotoreOpen = false;
                    this.isMaterialiOpen = false;
                    this.isPesiOpen = false;
                    this.isConsumiOpen = !this.isConsumiOpen;
                    this.isVarieOpen = false;
                    break;
                case 3:
                    this.isMotoreOpen = false;
                    this.isMaterialiOpen = false;
                    this.isPesiOpen = false;
                    this.isConsumiOpen = false;
                    this.isVarieOpen = !this.isVarieOpen;
                    break;
                case 4:
                    this.isMotoreOpen = false;
                    this.isMaterialiOpen = !this.isMaterialiOpen;
                    this.isPesiOpen = false;
                    this.isConsumiOpen = false;
                    this.isVarieOpen = false;
                    break;
            }
        }
    }
}
</script>

<style scoped>
.row-element {
    width: 100%;
    display: inline-block;
    border: 1px solid #ddd;
    border-top: none;
    background-color: #e9693254;
}

.row-element:nth-child(2n+0) {
    background-color: #e9693287;
}
</style>